export default __webpack_public_path__ + "static/assets/6a559591c59185e10a44460bfa2c7fcb.jpg";